import PropTypes from 'prop-types';
import { SnackbarProvider } from 'notistack';

import SnackbarIcon from './SnackbarIcon';

/**
 * Provides a Snackbar context using the notistack library,
 * with customized styles and icons for different types of notifications.
 *
 * @param {Object} props - Component properties.
 * @param {ReactNode} props.children - Children nodes to be rendered inside the provider.
 */
const NotistackProvider = ({ children }) => (
  <SnackbarProvider
    dense
    maxSnack={1}
    autoHideDuration={3000}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    style={{ marginTop: 'env(safe-area-inset-top)' }}
    iconVariant={{
      success: <SnackbarIcon icon="check_circle" />,
      error: <SnackbarIcon icon="info" />,
      warning: <SnackbarIcon icon="warning" />,
      info: <SnackbarIcon icon="error" />
    }}
  >
    {children}
  </SnackbarProvider>
);

NotistackProvider.propTypes = {
  children: PropTypes.node
};

export default NotistackProvider;
